import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators, UntypedFormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { setValidatorsV3, viewDocument } from 'src/app/controls/functions/functions';
import { cloneArray, formatDate, storage_url } from 'src/app/controls/functions/shared-functions';
import { jsonDeepParse, getInvalidFields, processValidationObject, deepMergeObjects } from 'src/app/functions/shared-functions';
import { getIP } from 'src/app/modules/jobseeker-registration/services/registration/jobseeker-registration.service';

import { ConfirmationComponent } from 'src/app/modules/shared/confirmation/confirmation.component';
import { FilesService } from 'src/app/services/shared/files/files.service';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { OfferDetailsService } from '../../services/offer-details/offer-details.service';

@Component({
  selector: 'offer-onb-field-details',
  templateUrl: './offer-onb-field-details.component.html',
  styleUrls: ['./offer-onb-field-details.component.scss'],
  providers: [FilesService]
})
export class OfferOnbFieldDetailsComponent implements OnInit {

  @Input() disabled_fields;
  @Input() field_config_access;
  @Input() form_details;
  @Input() type = 1;
  @Input() verificationRequired;
  @Input() verificationObj;
  @Input() other_data: any = {};
  @Input() callbackFn;
  @Input() alertId;
  @Input() disable_button;
  @Input() afterSaveAction;
  extended_fields_titles = {}
  stepperOrientation;
  enableSourceRef = 0;
  storage_url = storage_url;
  dynamic_sections;

  masters;
  dynamic_form = new UntypedFormGroup({})
  details;
  offerId;
  ip = getIP();
  current_date = formatDate(new Date());
  active_tab: any = {};
  // agreedStatus
  @ViewChild('stepper') stepper: MatStepper;

  // assessment =
  sign_upload_type = 1;

  constructor(
    private pre_offer_srv: OfferDetailsService,
    private dialog: MatDialog,
    private translate: TranslateService,
    private file_srv: FilesService,
    private el: ElementRef,
    private fb: UntypedFormBuilder,
    // private SectionProgressPipe: SectionProgressPipe,
    private notification_svc: NotificationService) {

  }

  ngOnInit(): void {
    // this.disabled_fields = 1;
    this.stepperOrientation = window.innerWidth < 900 ? 'vertical' : 'horizontal';
    if (this.field_config_access) {
      processValidationObject('offer_', this.field_config_access);
      console.log(this.field_config_access);
    }

    this.getPreOfferMasters();
  }







  ngOnChanges(ev): void {
    if (ev && ev.form_details) {
      this.patchValueToFormGroups()
    }
  }

  prepareSections(sections, form_group, form_builder, create_fg, value, parent_form) {
    if (sections && sections.length) {
      for (let i = 0; i < sections.length; i++) {
        let section = sections[i];
        section.field_label = {};
        // section.title = section.fieldID;
        if (create_fg) {
          if (section.multiple) {
            form_group.addControl(section.fieldID, form_builder.control());
          }
          else {
            if (section.fieldID == 'checklist_ref') {
              console.log('hrer')
            }
            form_group.addControl(section.fieldID, form_builder.group({}));
          }

        }
        if (section && section.enableQuestion) {
          let control_name = section.enableQuestion.fieldID;
          section.field_label.control_name = section.enableQuestion.label;
          if (section.multiple) {
            form_group.addControl(control_name, form_builder.control());
            setValidatorsV3(form_group, section.enableQuestion);
            section.field_label[section.enableQuestion.fieldID] = section.enableQuestion.label;
          }
          else {
            form_group.get(section.fieldID).addControl(control_name, form_builder.control());
            setValidatorsV3(form_group.get(section.fieldID), section.enableQuestion);
            section.field_label[section.enableQuestion.fieldID] = section.enableQuestion.label;
          }
        }

        if (section && section.multiple) {
          let multiple_form = new UntypedFormGroup({});
          multiple_form.addControl(section.fieldID, form_builder.group({}));
          section.gridLayout = [];
          this.addFieldsToGroup(multiple_form, section.sectionFields, form_builder, section, parent_form);
          section.multiple_form = multiple_form;
        }
        else {
          this.addFieldsToGroup(create_fg ? form_group.get(section.fieldID) : form_group, section.sectionFields, form_builder, section, parent_form);
        }

        if (section && section.sections) {
          this.prepareSections(section.sections, form_group.get(section.fieldID), form_builder, 1, value, parent_form);
        }
      }
    }
  }

  addFieldsToGroup(form_group, fields, form_builder, section, parent_form) {
    if (fields && fields.length) {
      for (let i = 0; i < fields.length; i++) {
        let field = fields[i];
        if ([16, 17, 20, 23, -1].indexOf(field.dataTypeId) == -1) {
          form_group.addControl(field.fieldID, form_builder.control());
          if (field.dataTypeId == 14) {
            if (field.ipFieldID) {
              form_group.addControl(field.ipFieldID, form_builder.control());
            }
            if (field.placeFieldID) {
              form_group.addControl(field.placeFieldID, form_builder.control());
            }
            if (field.dateFieldID) {
              form_group.addControl(field.dateFieldID, form_builder.control());
            }

          }
          section.field_label[field.fieldID] = field.label;
          if (field.dataTypeId == 11 && field.numberControl) {
            form_group.addControl(field.numberControl, form_builder.control());
            section.field_label[field.numberControl] = field.label;
          }
        }
        else if (field.dataTypeId == -1) {

          form_group.addControl(field.fieldID, form_builder.group({}));

          this.addFieldsToGroup(form_group.get(field.fieldID), field.addressFields, form_builder, section, parent_form)
        }
        else if (field.dataTypeId == 23) {
          // this.resentKeys.push(field.masterPropName);
          form_group.addControl(field.fieldID, form_builder.control({}));
          form_group.get(field.fieldID).patchValue(this.masters[field.masterPropName]);
          // this.createDeclarationDocumentsFormArray(this.masters, form_group, field);
        }
        else {

          form_group.addControl(field.fieldID, form_builder.array([]));
          if (field.dataTypeId == 16) {
            // this.resentKeys.push(field.masterPropName);
            this.createDocumentsFormArray(this.masters, form_group, field);
          }
          else if (field.dataTypeId == 17) {
            this.createChecklistFormArray(this.masters, form_group, field)
          }
          else if (field.dataTypeId == 20) {
            this.createAssessmentFromArray(this.masters, form_group, field)
          }
        }
        if (field.enable_virtual_scroll && !field.parent_key) {
          prepareMasters(field, this.form_details, this.masters, section)
        }

        if (field.suggestedValues && field.suggestedValues.length) {
          // this.masters[field.masterPropName].

          try {

            this.masters[field.fieldID + 'master'] = field.suggestedValues;
            field.masterPropName = field.fieldID + 'master';
          }
          catch (Err) {

          }
        }

        if (field.filterMasterIds && field.filterMasterIds.length) {
          // this.masters[field.masterPropName].

          try {
            let list = this.masters[field.masterPropName].filter(item => field.filterMasterIds.includes(item.id));
            this.masters[field.fieldID + 'master'] = list;
            field.masterPropName = field.fieldID + 'master';
          }
          catch (Err) {

          }
        }

        if (field.default_value) {
          form_group.get(field.fieldID).patchValue(field.default_value);
        }
        setValidatorsV3(form_group, field)
      }
    }
  }

  // createDeclarationDocumentsFormArray(){

  // }

  createChecklistFormArray(masters, form_group, field) {
    if (masters && masters[field.masterPropName]) {
      masters[field.masterPropName] = jsonDeepParse(masters[field.masterPropName]);
      masters[field.masterPropName].forEach(element => {
        let form_array = form_group.get(field.fieldID) as UntypedFormArray
        form_array.push(this.createCheckList(element));
      });
    }
  }
  createAssessmentFromArray(masters, form_group, field) {
    if (masters && masters[field.masterPropName]) {
      masters[field.masterPropName] = jsonDeepParse(masters[field.masterPropName]);
      masters[field.masterPropName].forEach(element => {
        let form_array = form_group.get(field.fieldID) as UntypedFormArray
        form_array.push(this.createAssessment(element));
      });
    }
  }
  createDocumentsFormArray(masters, form_group, field) {
    if (masters && masters[field.masterPropName]) {
      masters[field.masterPropName] = jsonDeepParse(masters[field.masterPropName]);
      masters[field.masterPropName].forEach(element => {
        let form_array = form_group.get(field.fieldID) as UntypedFormArray
        form_array.push(this.createExtendeDOCUMENTS(element));
      });
    }
  }
  stepChanged(ev, section) {
    console.log(ev);
    console.log(section);
  }
  patchValueToFormGroups() {
    try {
      if (this.form_details) {
        // this.personal_details_form.patchValue(this.form_details);
        // this.education_form.patchValue(this.form_details);
        // this.familyDetails.patchValue(this.form_details);
        // this.workHistory_form.patchValue(this.form_details);
        // this.ref_and_other_details_form.patchValue(this.form_details);
        // this.declaration_form.patchValue(this.form_details);
        // this.otherDetailsSection.patchValue(this.form_details);

        for (let i = 0; i < this.dynamic_sections.length; i++) {
          let sec = this.dynamic_sections[i];
          try {
            if (!sec.multiple) {
              this.dynamic_form.get(sec.fieldID).patchValue(this.form_details);
            }
            else {
              this.dynamic_form.get(sec.fieldID).patchValue(this.form_details[sec.fieldID]);
            }
            if (sec.sections) {
              this.patchToFg((sec.multiple || sec['enable_key']) ? this.dynamic_form : this.dynamic_form.get(sec.fieldID), sec.sections, this.form_details)
            }
          }
          catch (err) {
            console.log(err);
          }
        }

        // this.dynamic_form.patchValue(this.form_details)
      }
    }
    catch (err) {

    }
  }


  patchToFg(form_group, sections, value) {
    for (let i = 0; i < sections.length; i++) {
      let sec = sections[i];
      try {
        if (!sec.multiple) {
          form_group.get(sec.fieldID).patchValue(value);
        }
        else {
          form_group.get(sec.fieldID).patchValue(value[sec.fieldID]);
        }
        if (sec.sections) {
          this.patchToFg((sec.multiple || sec['enable_key']) ? this.dynamic_form : this.dynamic_form.get(sec.fieldID), sec.sections, sec.multiple || sec['enable_key'] ? this.form_details[sec.fieldID] : this.form_details)
        }
      }
      catch (err) {

      }
    }
  }




  viewDocument(all_files, file) {
    viewDocument(all_files, [], this.dialog, null);
  }

  createAssessment(element) {
    return new UntypedFormGroup({
      "qCode": new UntypedFormControl(element.qCode),
      "optionCode": new UntypedFormControl(element.optionCode),
      "inputAnswer": new UntypedFormControl(element.inputAnswer),
      "notes": new UntypedFormControl(element.notes)
    })
  }

  createCheckList(element) {
    return new UntypedFormGroup({
      "qCode": new UntypedFormControl(element.qCode),
      "selectedOptionCode": new UntypedFormControl(element.selectedOptionCode),
      // "inputAnswerOne": new FormControl(element.inputAnswerOne),
      "inputAnswerOne": new UntypedFormControl({ value: element.inputAnswerOne, disabled: false }),
      "inputAnswerTwo": new UntypedFormControl({ value: element.inputAnswerTwo, disabled: true })
    })
  }

  createExtendeDOCUMENTS(elemnt) {
    // elemnt = jsonDeepParse(elemnt);
    let validators = [];
    if (elemnt.UIValidationObjStruct) {
      try {
        if (elemnt.UIValidationObjStruct.mandatory == 1) {
          validators.push(Validators.required)
        }
      }
      catch (err) {

      }
    }
    return new UntypedFormGroup({
      attachLabel: new UntypedFormControl(elemnt.attachLabel),
      attachValue: new UntypedFormControl(elemnt.attachValue, validators),
      fieldCode: new UntypedFormControl(elemnt.fieldCode),
      mandatory: new UntypedFormControl(elemnt.mandatory),
      title: new UntypedFormControl(elemnt.title),
      UIValidationObjStruct: new UntypedFormControl(elemnt.UIValidationObjStruct),
    })

  }

  sourceRefCheck(ev) {
    if (ev && ev.enableSourceRef) {
      this.enableSourceRef = parseInt(ev.enableSourceRef);
    }
    else {
      this.enableSourceRef = 0;
    }
  }



  //1 personal_details_form
  //2 education_form
  //3 familyDetails_singleForm
  //4 workHistory_form
  //5 ref_and_other_details_form
  //6 extendedData
  //7 declaration_form


  submitPreOfferDetails(obj) {

    if (obj && obj.value) {
      obj.value.verificationStatus = this.verificationObj;

      obj.value.type = this.type;
      console.log(obj.value);
      // let save_obj = {}
      let req: any = {}
      try {
        console.log(this.form_details)
        req = deepMergeObjects(this.form_details, obj.value);
        if (this.alertId) {
          req.alertId = this.alertId;
        }
      }
      catch (err) {
        console.log(err)
        req = obj.value;
      }
      console.log(req);
      this.pre_offer_srv.submitPreOfferDetails(req).subscribe(res => {
        if (res && res['status']) {
          if (obj.value.finalSubmit) {
            this.notification_svc.success(res['message'], 'Close', 5000);
          }
          if (obj.callbacFn) {
            obj.callbacFn(obj.currentIndex);
          }
          if (this.afterSaveAction && obj.value.finalSubmit) {
            this.afterSaveAction(1)
          }
        }
        else {
          this.notification_svc.error(res['message'], 'Close', 5000)
        }
      })
    }
    else {
      this.notification_svc.error("Form is invalid", "Close", 5000)
    }

  }

  submitOnbDetails(obj) {
    this.pre_offer_srv.submitOnboardingDetails(obj).subscribe(res => {
      if (res && res['status']) {
        this.notification_svc.success(res['message'], 'Close', 5000);
        this.stepper.next();
      }
      else {
        this.notification_svc.error(res['message'], 'Close', 5000)
      }
    })
  }



  getPreOfferMasters() {
    if (this.other_data) {
      this.other_data.type = this.type;
    }
    this.pre_offer_srv.getPreOfferMasters(this.other_data).subscribe(res => {
      if (res && res['status']) {
        this.masters = jsonDeepParse(res['data']);
        console.log(this.masters)
        try {
          if (this.type == 3) {
            this.verificationRequired = this.masters.defaultConfig.companySettingsJson.enableVerificationForOffer
          }
          if (this.type == 4) {
            this.verificationRequired = this.masters.defaultConfig.companySettingsJson.enableVerificationForOnboarding
          }
        }
        catch (err) {

        }
        this.dynamic_sections = this.masters.formJSON;
        // this.dynamic_sections = [
        // {
        //   "validators": {
        //     "min_length": 0,
        //     "max_length": 0
        //   },
        //   "enableApiCallForVerification": 1,
        //   "fieldID": "offer_personalDetails",
        //   "label": "Personal Details",
        //   "sub_section_display_type": 1,
        //   "enableNotes": 1,
        //   "notesType": 1000,
        //   "sectionFields": [
        //     {
        //       "fieldID": "reqType",
        //       "label": "Req Type",
        //       "placeholder": "Req Type",
        //       "dataTypeId": 2,
        //       "width": 3,
        //       "transform": 1,
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": 0
        //         },
        //         "hide": {
        //           "value": 1
        //         }
        //       }
        //     },
        //     {
        //       "fieldID": "offeredCTC",
        //       "label": "Offered CTC",
        //       "placeholder": "Offered CTC",
        //       "dataTypeId": 2,
        //       "width": 3,
        //       "transform": 1,
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": 0
        //         },
        //         "hide": {
        //           "value": 1
        //         }
        //       }
        //     },
        //     {
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": 0
        //         }
        //       },
        //       "fieldID": "profilePhoto",
        //       "label": "Profile Picture",
        //       "placeholder": "profile Picture",
        //       "width": 4,
        //       "documentValidation": [
        //         "pdf",
        //         "doc",
        //         "docx",
        //         "jpeg",
        //         "png",
        //         "jpg",
        //         "xlsx",
        //         "xlsm",
        //         "jfif",
        //         "mp3",
        //         "ogv",
        //         "wav",
        //         "amr",
        //         "ogg",
        //         "xls",
        //         "svg"
        //       ],
        //       "dataTypeId": 5
        //     },
        //     {
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": 1
        //         }
        //       },
        //       "fieldID": "salutationId",
        //       "label": "Salutation",
        //       "placeholder": "Select Salutation",
        //       "masterPropName": "salutationList",
        //       "dataTypeId": 8,
        //       "width": 4
        //     },
        //     {
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": "1"
        //         },
        //         "hide": {
        //           "condition": 0,
        //           "value": 0
        //         },
        //         "finalPattern": {
        //           "value": "[a-z]"
        //         },
        //         "disable": {
        //           "value": 0
        //         }
        //       },
        //       "fieldID": "firstName",
        //       "label": "First Name",
        //       "placeholder": "Enter first name",
        //       "dataTypeId": 1,
        //       "width": 4,
        //       "transform": 1
        //     },
        //     {
        //       "UIValidationObjStruct": {
        //         "hide": {
        //           "condtion": 1,
        //           "value": "1"
        //         }
        //       },
        //       "fieldID": "alertId",
        //       "label": "",
        //       "placeholder": "",
        //       "dataTypeId": 1
        //     },
        //     {
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": "1"
        //         }
        //       },
        //       "fieldID": "middleName",
        //       "label": "Middle Name",
        //       "placeholder": "Enter middle name",
        //       "width": 4,
        //       "dataTypeId": 1,
        //       "transform": 1
        //     },
        //     {
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": "1"
        //         }
        //       },
        //       "fieldID": "lastName",
        //       "label": "Last Name",
        //       "placeholder": "Enter last name",
        //       "width": 4,
        //       "dataTypeId": 1,
        //       "transform": 1
        //     },
        //     {
        //       "fieldID": "gender",
        //       "label": "Gender",
        //       "placeholder": "Select Gender",
        //       "masterPropName": "genderList",
        //       "width": 4,
        //       "dataTypeId": 8,
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": "1"
        //         }
        //       }
        //     },
        //     {
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": "1"
        //         }
        //       },
        //       "fieldID": "dob",
        //       "label": "Date of birth",
        //       "placeholder": "Select Date of birth",
        //       "width": 4,
        //       "dataTypeId": 3
        //     },
        //     {
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": "1"
        //         }
        //       },
        //       "fieldID": "emailId",
        //       "label": "Email ID",
        //       "placeholder": "Enter Email ID",
        //       "width": 4,
        //       "dataTypeId": 1
        //     },
        //     {
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": "1"
        //         }
        //       },
        //       "fieldID": "mobileIsd",
        //       "numberControl": "mobileNumber",
        //       "label": "Mobile Number",
        //       "placeholder": "Select Country Code",
        //       "numberControlPlaceholder": "Enter number",
        //       "width": 4,
        //       "dataTypeId": 11
        //     },
        //     // {
        //     //   "masterPropName": "isdCountryList",
        //     //   "dataTypeId": 8,
        //     //   "width": 1,
        //     //   "controlClass": "pr-0",
        //     //   "UIValidationObjStruct": {
        //     //     "mandatory": {
        //     //       "value": 0
        //     //     }
        //     //   },
        //     //   "fieldID": "altMobileIsd",
        //     //   "label": "ISD",
        //     //   "placeholder": "< - - Select - - >"
        //     // },
        //     {
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": 0
        //         }
        //       },
        //       "fieldID": "altMobileIsd",
        //       "label": "Phone Number",
        //       "masterPropName": "isdCountryList",
        //       "numberControl": "mobileNumber",
        //       "placeholder": "Enter Number",
        //       "width": 4,
        //       "dataTypeId": 11
        //     },
        //     {
        //       "masterPropName": "nationalityList",
        //       "dataTypeId": 8,
        //       "width": 4,
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": 0
        //         }
        //       },
        //       "fieldID": "nationalityId",
        //       "label": "Nationality",
        //       "placeholder": "Select Nationality"
        //     },
        //     {
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": "1"
        //         }
        //       },
        //       "fieldID": "maritalStatusId",
        //       "label": "Marital Status",
        //       "placeholder": "Select Marital Status",
        //       "masterPropName": "maritalStatusList",
        //       "lineBreak": "1",
        //       "width": 4,
        //       "dataTypeId": 8
        //     },
        //     {
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "condition": "(!form_group.value['maritalStatusId']||form_group.value['maritalStatusId'] == 1 || form_group.value['maritalStatusId'] == 4)? 0 : 1",
        //           "value": 0
        //         },
        //         "hide": {
        //           "condition": "(!form_group.value['maritalStatusId']||form_group.value['maritalStatusId'] == 1 || form_group.value['maritalStatusId'] == 4)? 1 : 0",
        //           "value": 0
        //         },
        //         "documentValidation": [
        //           "pdf",
        //           "doc",
        //           "docx",
        //           "jpeg",
        //           "png",
        //           "jpg",
        //           "xlsx",
        //           "xlsm",
        //           "jfif",
        //           "mp3",
        //           "ogv",
        //           "wav",
        //           "amr",
        //           "ogg",
        //           "xls",
        //           "svg"
        //         ]
        //       },
        //       "fieldID": "marriageCertificateAttachments",
        //       "label": "Marriage Certificate/Document",
        //       "placeholder": "Attach Marriage Certificate/Document",
        //       "dataTypeId": 5
        //     },
        //     {
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": "1"
        //         }
        //       },
        //       "fieldID": "bloodGroup",
        //       "label": "Blood Group",
        //       "placeholder": "< - - Select - - >",
        //       "masterPropName": "bloodGroupList",
        //       "width": 4,
        //       "dataTypeId": 8
        //     },
        //     {
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": "1"
        //         },
        //         "pattern": {
        //           "value": "^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$"
        //         },
        //         "max_length": {
        //           "value": "12"
        //         }
        //       },
        //       "fieldID": "aadharNumber",
        //       "label": "Aadhar Number",
        //       "placeholder": "Enter Aadhar Number",
        //       "width": 4,
        //       "lineBreak": "1",
        //       "dataTypeId": 1
        //     },
        //     {
        //       "fieldID": "aadharAttach",
        //       "label": "E-aadhar Card(Unmasked Aadhar to be uploaded)",
        //       "placeholder": "E-aadhar Card(Unmasked Aadhar to be uploaded)",
        //       "dataTypeId": 6,
        //       "width": 4,
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": "1"
        //         }
        //       }
        //     },
        //     {
        //       "fieldID": "hasAppliedForPAN",
        //       "label": "Applied for Pan Card",
        //       "placeholder": "< - - Select - - >",
        //       "dataTypeId": 18,
        //       "width": 4,
        //       "lineBreak": "1",
        //       "parent_key": "extendedFields",
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": 0
        //         }
        //       }
        //     },
        //     {
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "condition": "(form_group.value['hasAppliedForPAN'] == 1 || form_group.value['hasAppliedForPAN'] == 4)? 0 : 1",
        //           "value": 1
        //         },
        //         "pattern": {
        //           "value": "[A-Z]{5}[0-9]{4}[A-Z]{1}"
        //         }
        //       },
        //       "fieldID": "panCardNumber",
        //       "label": "PAN Number",
        //       "placeholder": "Enter PAN",
        //       "width": 4,
        //       "dataTypeId": 1,
        //       "transform": 1
        //     },
        //     {
        //       "fieldID": "panAttach",
        //       "label": "Pan Card",
        //       "placeholder": "Pan card",
        //       "dataTypeId": 6,
        //       "width": 4,
        //       "file_size_validation": {
        //         "size": 10,
        //         "unit": "KB"
        //       },
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "condition": "(form_group.value['hasAppliedForPAN'] == 1 || form_group.value['hasAppliedForPAN'] == 4)? 0 : 1",
        //           "value": "1"
        //         }
        //       }
        //     },
        //     {
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": "1"
        //         }
        //       },
        //       "fieldID": "vaccinationStatus",
        //       "label": "Vaccination Status",
        //       "placeholder": "< - - Select - - >",
        //       "masterPropName": "vaccinationStatusList",
        //       "width": 4,
        //       "dataTypeId": 8
        //     },
        //     {
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": "1"
        //         }
        //       },
        //       "fieldID": "fatherName",
        //       "label": "Father's Name",
        //       "placeholder": "Enter Father's Name",
        //       "width": 4,
        //       "dataTypeId": 1
        //     },
        //     {
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": "1"
        //         }
        //       },
        //       "fieldID": "religion",
        //       "label": "Religion",
        //       "placeholder": "Enter Religion",
        //       "width": 4,
        //       "dataTypeId": 1
        //     },
        //     {
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": "1"
        //         }
        //       },
        //       "fieldID": "EAadharSeedingStatus",
        //       "label": "E-Aadhar Seeding Status",
        //       "placeholder": "Select E-Aadhar Seeding Status",
        //       "suggestedValues": [
        //         {
        //           "id": "Pending",
        //           "title": "Pending"
        //         },
        //         {
        //           "id": "Completed",
        //           "title": "Completed"
        //         }
        //       ],
        //       "width": 4,
        //       "dataTypeId": 12
        //     },
        //     {
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": 0
        //         }
        //       },
        //       "fieldID": "placeOfBirth",
        //       "label": "Place of Birth",
        //       "placeholder": "Enter Place of Birth",
        //       "width": 4,
        //       "dataTypeId": 1
        //     },
        //     {
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": 0
        //         }
        //       },
        //       "fieldID": "motherTongueId",
        //       "label": "Mother Tongue",
        //       "placeholder": "Enter Mother Tongue",
        //       "width": 4,
        //       "masterPropName": "languageList",
        //       "dataTypeId": 8
        //     },
        //     {
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": 0
        //         },
        //         "max_length": {
        //           "value": 12
        //         }
        //       },
        //       "fieldID": "ppNumber",
        //       "label": "Passport Number",
        //       "placeholder": "Enter Passport Number",
        //       "width": 4,
        //       "dataTypeId": 1,
        //       "transform": 1
        //     },
        //     {
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": 0
        //         }
        //       },
        //       "fieldID": "ppIssueDate",
        //       "label": "Passport Issued Date",
        //       "placeholder": "Select Passport Issued Date",
        //       "dataTypeId": 3
        //     },
        //     {
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": 0
        //         }
        //       },
        //       "fieldID": "ppExpiryDate",
        //       "label": "Passport Expiry Date",
        //       "placeholder": "Select Expiry Date",
        //       "dataTypeId": 3
        //     },
        //     {
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": 0
        //         },
        //         "max_length": {
        //           "value": 16
        //         },
        //         "pattern": {
        //           "value": "^[A-Z]{2}[0-9]{14}$"
        //         }
        //       },
        //       "fieldID": "drivingLicense",
        //       "label": "Driving Licence Number",
        //       "placeholder": "Enter Driving Licence Number",
        //       "width": 4,
        //       "dataTypeId": 1,
        //       "transform": 1
        //     },
        //     {
        //       "fieldID": "localAddress",
        //       "label": "Present Address",
        //       "dataTypeId": -1,
        //       "width": 6,
        //       "lineBreak": "1",
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": "1"
        //         }
        //       },
        //       "addressFields": [
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": "1"
        //             }
        //           },
        //           "fieldID": "addressLine1",
        //           "label": "Address line 1",
        //           "placeholder": "Enter address line 1",
        //           "dataTypeId": 1,
        //           "width": 12
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             }
        //           },
        //           "fieldID": "addressLine2",
        //           "label": "Address line 2",
        //           "placeholder": "Enter address line 2",
        //           "dataTypeId": 1,
        //           "width": 12
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": "1"
        //             }
        //           },
        //           "fieldID": "cityId",
        //           "label": "City",
        //           "masterPropName": "cityList",
        //           "placeholder": "< - -  Select - - >",
        //           "dataTypeId": 8,
        //           "width": 6,
        //           "expression": "form_group.get('stateName').enable();form_group.get('countryName').enable();form_group.patchValue(ev)"
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             },
        //             "disabled": {
        //               "value": 1
        //             }
        //           },
        //           "fieldID": "stateName",
        //           "label": "State",
        //           "placeholder": "< - -  Select - - >",
        //           "dataTypeId": 1,
        //           "width": 6
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             },
        //             "disabled": {
        //               "value": 0
        //             }
        //           },
        //           "fieldID": "countryName",
        //           "label": "Country",
        //           "placeholder": "< - -  Select - - >",
        //           "dataTypeId": 1,
        //           "width": 6
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": "1"
        //             }
        //           },
        //           "fieldID": "postalCode",
        //           "label": "Postal Code",
        //           "placeholder": "Enter Postal Code",
        //           "dataTypeId": 2,
        //           "width": 6
        //         }
        //       ]
        //     },
        //     {
        //       "fieldID": "permanentAddress",
        //       "label": "Permanent Address",
        //       "dataTypeId": -1,
        //       "width": 6,
        //       "enableCopy": "1",
        //       "copyFrom": "localAddress",
        //       "copyAddresslabel": "Copy Present Address",
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": "1"
        //         }
        //       },
        //       "addressFields": [
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": "1"
        //             }
        //           },
        //           "fieldID": "addressLine1",
        //           "label": "Address line 1",
        //           "placeholder": "Enter address line 1",
        //           "dataTypeId": 1,
        //           "width": 12
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             }
        //           },
        //           "fieldID": "addressLine2",
        //           "label": "Address line 2",
        //           "placeholder": "Enter address line 2",
        //           "dataTypeId": 1,
        //           "width": 12
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": "1"
        //             }
        //           },
        //           "fieldID": "cityId",
        //           "label": "City",
        //           "masterPropName": "cityList",
        //           "placeholder": "< - -  Select - - >",
        //           "dataTypeId": 8,
        //           "width": 6,
        //           "expression": "form_group.get('stateName').enable();form_group.get('countryName').enable();form_group.patchValue(ev)"
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             },
        //             "disabled": {
        //               "value": 1
        //             }
        //           },
        //           "fieldID": "stateName",
        //           "label": "State",
        //           "placeholder": "< - -  Select - - >",
        //           "dataTypeId": 1,
        //           "width": 6
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             },
        //             "disabled": {
        //               "value": 0
        //             }
        //           },
        //           "fieldID": "countryName",
        //           "label": "Country",
        //           "placeholder": "< - -  Select - - >",
        //           "dataTypeId": 1,
        //           "width": 6
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": "1"
        //             }
        //           },
        //           "fieldID": "postalCode",
        //           "label": "Postal Code",
        //           "placeholder": "Enter Postal Code",
        //           "dataTypeId": 2,
        //           "width": 6
        //         }
        //       ]
        //     }
        //   ],
        //   "sections": [
        //     {
        //       "validators": {
        //         "multiple": 0,
        //         "min_length": 0,
        //         "max_length": 0
        //       },
        //       "fieldID": "emergencyContacts",
        //       "label": "Emergency Contact",
        //       "display_type": "1",
        //       "multiple": 1,
        //       "sectionFields": [
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 1
        //             }
        //           },
        //           "fieldID": "name",
        //           "label": "Contact Name",
        //           "placeholder": "Enter Contact Name",
        //           "dataTypeId": 1,
        //           "width": 3,
        //           "transform": 1
        //         },
        //         {
        //           "fieldID": "relationTypeId",
        //           "label": "Relationship",
        //           "placeholder": "Select Relationship",
        //           "masterPropName": "relationTypeList",
        //           "width": 3,
        //           "dataTypeId": 8,
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 1
        //             }
        //           }
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             }
        //           },
        //           "fieldID": "phoneIsd",
        //           "numberControl": "phoneNumber",
        //           "label": "Phone no",
        //           "placeholder": "Select Country Code",
        //           "numberControlPlaceholder": "Enter number",
        //           "dataTypeId": 11,
        //           "width": 3
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 1
        //             }
        //           },
        //           "fieldID": "mobileIsd",
        //           "numberControl": "mobileNumber",
        //           "label": "Mobile Number",
        //           "placeholder": "Select Country Code",
        //           "numberControlPlaceholder": "Enter Mobile Number",
        //           "dataTypeId": 11,
        //           "width": 3
        //         }
        //       ]
        //     },
        //     {
        //       "validators": {
        //         "multiple": 0,
        //         "min_length": 0,
        //         "max_length": 0
        //       },
        //       "fieldID": "bank_details_other",
        //       "label": "Bank Details",
        //       "display_type": "1",
        //       "sub_section_display_type": 1,
        //       "sectionFields": [
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             }
        //           },
        //           "fieldID": "bankName",
        //           "label": "Bank Name",
        //           "placeholder": "Enter Bank Name",
        //           "masterPropName": "bankNamesMasterList",
        //           "dataTypeId": 8
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             }
        //           },
        //           "type": {
        //             "type1": "text",
        //             "type2": "text"
        //           },
        //           "fieldID": "accountNumber",
        //           "label": "Account Number",
        //           "placeholder": "Enter Account Number",
        //           "dataTypeId": 24
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             }
        //           },
        //           "fieldID": "bankAccountType",
        //           "label": "Type of account",
        //           "placeholder": "Select Type of account",
        //           "suggestedValues": [
        //             {
        //               "id": "Savings Account",
        //               "title": "Savings Account"
        //             },
        //             {
        //               "id": "Current Account",
        //               "title": "Current Account"
        //             },
        //             {
        //               "id": "Salary Account",
        //               "title": "Salary Account"
        //             }
        //           ],
        //           "dataTypeId": 8
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             },
        //             "max_length": {
        //               "value": 11
        //             },
        //             "pattern": {
        //               "value": "^[A-Za-z]{4}[0][A-Z0-9a-z]{6}$"
        //             }
        //           },
        //           "fieldID": "bankIFSCCode",
        //           "label": "IFSC Code",
        //           "placeholder": "Enter bank IFS Code",
        //           "dataTypeId": 1
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             }
        //           },
        //           "fieldID": "bankBranch",
        //           "label": "Branch",
        //           "placeholder": "Enter Bank Branch",
        //           "dataTypeId": 1
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             }
        //           },
        //           "fieldID": "bankAddress",
        //           "label": "Bank Location",
        //           "placeholder": "Enter Bank Location",
        //           "dataTypeId": 1
        //         }
        //       ]
        //     },
        //     {
        //       "multiple": 1,
        //       "validators": {
        //         "min_length": 1,
        //         "max_length": 0
        //       },
        //       "fieldID": "bankDocList",
        //       "label": "Bank Document(Any one document is mandatory)",
        //       "sub_section_display_type": 1,
        //       "sectionFields": [
        //         {
        //           "fieldID": "docTypeId",
        //           "label": "Document",
        //           "placeholder": "< - - Select - - >",
        //           "masterPropName": "bankDocTypeList",
        //           "dataTypeId": 8,
        //           "width": 3,
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": "0"
        //             }
        //           }
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": "1"
        //             },
        //             "documentValidation": [
        //               "pdf",
        //               "doc",
        //               "docx",
        //               "jpeg",
        //               "png",
        //               "jpg",
        //               "xlsx",
        //               "xlsm",
        //               "jfif",
        //               "mp3",
        //               "ogv",
        //               "wav",
        //               "amr",
        //               "ogg",
        //               "xls",
        //               "svg"
        //             ]
        //           },
        //           "fieldID": "attachValue",
        //           "label": "Upload Document",
        //           "placeholder": "Choose File",
        //           "width": 4,
        //           "dataTypeId": 5
        //         }
        //       ]
        //     }
        //   ]
        // },
        // {
        //   "validators": {
        //     "min_length": 1,
        //     "max_length": 0
        //   },
        //   "fieldID": "educations_ref",
        //   "label": "Education Details with Attachments",
        //   "sub_section_display_type": 1,
        //   "sections": [
        //     {
        //       "multiple": 1,
        //       "validators": {
        //         "min_length": 1,
        //         "max_length": 0
        //       },
        //       "fieldID": "educations",
        //       "label": "Education Details",
        //       "sub_section_display_type": 1,
        //       "table_grid": [{
        //         "property": "isHighEdu",
        //         "title": "Highest Qualification"
        //       },
        //       {
        //         "property": "educationType"
        //       },
        //       {
        //         "property": "educationCode"
        //       },
        //       {
        //         "property": "specializationCode"
        //       },
        //       {
        //         "property": "passingMN"
        //       },
        //       {
        //         "property": "universityCode"
        //       }
        //       ],
        //       "sectionFields": [
        //         {
        //           "fieldID": "isHighEdu",
        //           "label": "Is it Highest Qualification",
        //           "placeholder": "< - - Select - - >",
        //           "dataTypeId": 13,
        //           "width": 3,
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             }
        //           }
        //         },
        //         {
        //           "fieldID": "educationType",
        //           "label": "Education Type",
        //           "placeholder": "< - - Select - - >",
        //           "masterPropName": "eduTypeList",
        //           "dataTypeId": 8,
        //           "width": 3,
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             }
        //           }
        //         },
        //         {
        //           "fieldID": "educationCode",
        //           "label": "Education",
        //           "placeholder": "< - - Select - - >",
        //           "masterPropName": "educationList",
        //           "dataTypeId": 8,
        //           "width": 3,
        //           "expression": "form_group.patchValue(ev)",
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": "1"
        //             }
        //           }
        //         },
        //         {
        //           "fieldID": "educationLevel",
        //           "label": "Education",
        //           "placeholder": "< - - Select - - >",
        //           "dataTypeId": 1,
        //           "width": 3,
        //           "UIValidationObjStruct": {
        //             "hide": {
        //               "value": 1
        //             }
        //           }
        //         },
        //         {
        //           "fieldID": "specializationCode",
        //           "label": "Specialization",
        //           "placeholder": "< - - Select - - >",
        //           "masterPropName": "specializationList",
        //           "width": 3,
        //           "dataTypeId": 8,
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             }
        //           }
        //         },
        //         {
        //           "fieldID": "passingMN",
        //           "label": "Month & Year of Passing",
        //           "placeholder": "Select Month & Year of Passing",
        //           "dataTypeId": 19,
        //           "width": 3,
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             }
        //           }
        //         },
        //         {
        //           "fieldID": "universityCode",
        //           "label": "University",
        //           "placeholder": "< - - Select - - >",
        //           "masterPropName": "universityList",
        //           "dataTypeId": 8,
        //           "enable_virtual_scroll": 1,
        //           "api_route": "searchUniversity",
        //           "masterTitleProperty": "universityTitle",
        //           "width": 3,
        //           "parent_key": "extendedFields",
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             }
        //           }
        //         },
        //         {
        //           "fieldID": "collegeCode",
        //           "label": "Institute Name",
        //           "placeholder": "< - - Select - - >",
        //           "masterPropName": "collegeList",
        //           "dataTypeId": 8,
        //           "enable_virtual_scroll": 1,
        //           "api_route": "searchCollege",
        //           "masterTitleProperty": "collegeTitle",
        //           "width": 3,
        //           "save_title_parent_key": "extendedFields",
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             }
        //           }
        //         }
        //       ]
        //     },
        //     {
        //       "multiple": 0,
        //       "validators": {
        //         "min_length": 1,
        //         "max_length": 0
        //       },
        //       "fieldID": "educationDocList",
        //       "label": "Education Attachments",
        //       "sub_section_display_type": 1,
        //       "sectionFields": [
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             },
        //             "hide": {
        //               "value": 1
        //             }
        //           },
        //           "fieldID": "educationLevel",
        //           "label": "Education Attachment Hide",
        //           "placeholder": "Education Attachment",
        //           "width": 4,
        //           "dataTypeId": 1
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             },
        //             "documentValidation": [
        //               "pdf",
        //               "doc",
        //               "docx",
        //               "jpeg",
        //               "png",
        //               "jpg",
        //               "xlsx",
        //               "xlsm",
        //               "jfif",
        //               "mp3",
        //               "ogv",
        //               "wav",
        //               "amr",
        //               "ogg",
        //               "xls",
        //               "svg"
        //             ]
        //           },
        //           "fieldID": "twelvethMarkAttach",
        //           "label": "XIIth Mark sheet",
        //           "placeholder": "Choose File",
        //           "width": 4,
        //           "dataTypeId": 5
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "condition": "parent_form.value['educations'] && parent_form.value['educations'].length && parent_form.value['educations'].find(res=>{return res.isHighEdu}) && parent_form.value['educations'].find(res=>{return res.isHighEdu}).educationLevel == 6 ? 1 : 0",
        //               "value": 0
        //             },
        //             "documentValidation": [
        //               "pdf",
        //               "doc",
        //               "docx",
        //               "jpeg",
        //               "png",
        //               "jpg",
        //               "xlsx",
        //               "xlsm",
        //               "jfif",
        //               "mp3",
        //               "ogv",
        //               "wav",
        //               "amr",
        //               "ogg",
        //               "xls",
        //               "svg"
        //             ]
        //           },
        //           "fieldID": "gradMarkAttach",
        //           "label": "Graduation mark sheet",
        //           "placeholder": "Choose File",
        //           "width": 4,
        //           "dataTypeId": 5
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "condition": "parent_form.value['educations'] && parent_form.value['educations'].length && parent_form.value['educations'].find(res=>{return res.isHighEdu}) && parent_form.value['educations'].find(res=>{return res.isHighEdu}).educationLevel == 7 ? 1 : 0",
        //               "value": 0
        //             },
        //             "documentValidation": [
        //               "pdf",
        //               "doc",
        //               "docx",
        //               "jpeg",
        //               "png",
        //               "jpg",
        //               "xlsx",
        //               "xlsm",
        //               "jfif",
        //               "mp3",
        //               "ogv",
        //               "wav",
        //               "amr",
        //               "ogg",
        //               "xls",
        //               "svg"
        //             ]
        //           },
        //           "fieldID": "postGradMarkAttach",
        //           "label": "Post Graduation mark sheet",
        //           "placeholder": "Choose File",
        //           "width": 4,
        //           "dataTypeId": 5
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             },
        //             "documentValidation": [
        //               "pdf",
        //               "doc",
        //               "docx",
        //               "jpeg",
        //               "png",
        //               "jpg",
        //               "xlsx",
        //               "xlsm",
        //               "jfif",
        //               "mp3",
        //               "ogv",
        //               "wav",
        //               "amr",
        //               "ogg",
        //               "xls",
        //               "svg"
        //             ]
        //           },
        //           "fieldID": "gradCertiAttach",
        //           "label": "Graduation Certificates",
        //           "placeholder": "Choose File",
        //           "width": 4,
        //           "dataTypeId": 5
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             },
        //             "documentValidation": [
        //               "pdf",
        //               "doc",
        //               "docx",
        //               "jpeg",
        //               "png",
        //               "jpg",
        //               "xlsx",
        //               "xlsm",
        //               "jfif",
        //               "mp3",
        //               "ogv",
        //               "wav",
        //               "amr",
        //               "ogg",
        //               "xls",
        //               "svg"
        //             ]
        //           },
        //           "fieldID": "postGradCertiAttach",
        //           "label": "Post Graduation Certificates",
        //           "placeholder": "Choose File",
        //           "width": 4,
        //           "dataTypeId": 5
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             },
        //             "documentValidation": [
        //               "pdf",
        //               "doc",
        //               "docx",
        //               "jpeg",
        //               "png",
        //               "jpg",
        //               "xlsx",
        //               "xlsm",
        //               "jfif",
        //               "mp3",
        //               "ogv",
        //               "wav",
        //               "amr",
        //               "ogg",
        //               "xls",
        //               "svg"
        //             ]
        //           },
        //           "fieldID": "allCertiAttach",
        //           "label": "Certificates",
        //           "placeholder": "Choose File",
        //           "width": 4,
        //           "dataTypeId": 5
        //         }
        //       ]
        //     }
        //   ]
        // },
        // {
        //   "validators": {
        //     "multiple": 0,
        //     "min_length": 0,
        //     "max_length": 0,
        //     "hide": {
        //       "condition": "parent_form['value']['reqType']==1 ? 1:0",
        //       "value": 0
        //     }
        //   },
        //   "fieldID": "offer_workExperience",
        //   "enableApiCallForVerification": 1,
        //   "enableNotes": 1,
        //   "notesType": 1003,
        //   "label": "Employer Details",
        //   "sub_section_display_type": 1,
        //   "sectionFields": [
        //     {
        //       "fieldID": "totalExperience",
        //       "label": "Total Experience (In Years)",
        //       "placeholder": "Enter Total Experience",
        //       "dataTypeId": 2,
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": 0
        //         },
        //         "disabled": {
        //           "value": 1
        //         }
        //       }
        //     }
        //   ],
        //   "sections": [
        //     {
        //       "validators": {
        //         "multiple": 1,
        //         "min_length": 0,
        //         "max_length": 0
        //       },
        //       "fieldID": "workHistory",
        //       "label": "Have worked previously?",
        //       "multiple": 1,
        //       "display_type": "1",
        //       "sub_section_display_type": 1,
        //       "enableQuestion": {
        //         "fieldID": "hasWorkedBefore",
        //         "label": "Have worked previously?",
        //         "masterPropName": "yesNoList",
        //         "UIValidationObjStruct": {
        //           "mandatory": {
        //             "value": 0
        //           }
        //         }
        //       },
        //       "sectionFields": [
        //         {
        //           "validators": {
        //             "multiple": 0,
        //             "min_length": 0,
        //             "max_length": 0
        //           },
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "condition": "form_group.value['hasWorkedBefore'] == 1 ? 1 : 0",
        //               "value": ""
        //             }
        //           },
        //           "fieldID": "employmentType",
        //           "label": "Employment Type",
        //           "placeholder": "Select Employment Type",
        //           "suggestedValues": [
        //             {
        //               "id": "Full Time",
        //               "title": "Full Time"
        //             },
        //             {
        //               "id": "Part Time",
        //               "title": "Part Time"
        //             }
        //           ],
        //           "dataTypeId": 8,
        //           "width": 3
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "condition": "form_group.value['hasWorkedBefore'] == 1 ? 1 : 0",
        //               "value": ""
        //             }
        //           },
        //           "fieldID": "employmentStatus",
        //           "label": "Employment Status",
        //           "placeholder": "Select Employment Status",
        //           "suggestedValues": [
        //             {
        //               "id": "Present",
        //               "title": "Present"
        //             },
        //             {
        //               "id": "Previous",
        //               "title": "Previous"
        //             }
        //           ],
        //           "dataTypeId": 8,
        //           "width": 3
        //         },
        //         {
        //           "fieldID": "companyName",
        //           "label": "Name Of The Company",
        //           "placeholder": "Enter Company Name",
        //           "dataTypeId": 1,
        //           "width": 3,
        //           "transform": 1,
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "condition": "form_group.value['hasWorkedBefore'] == 1 ? 1 : 0",
        //               "value": "1"
        //             }
        //           }
        //         },
        //         {
        //           "fieldID": "designationTitle",
        //           "label": "Designation",
        //           "placeholder": "Select Designation",
        //           "masterPropName": "jobTitleList",
        //           "dataTypeId": 1,
        //           "width": 3,
        //           "transform": 1,
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "condition": "form_group.value['hasWorkedBefore'] == 1 ? 1 : 0",
        //               "value": ""
        //             }
        //           }
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "condition": "form_group.value['hasWorkedBefore'] == 1 ? 1 : 0",
        //               "value": ""
        //             }
        //           },
        //           "fieldID": "dateOfJoining",
        //           "label": "Start Date",
        //           "placeholder": "Select Start Date",
        //           "width": 3,
        //           "dataTypeId": 3
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "condition": "form_group.value['hasWorkedBefore'] == 1 ? 1 : 0",
        //               "value": ""
        //             }
        //           },
        //           "fieldID": "dateOfRelieving",
        //           "label": "End Date",
        //           "placeholder": "Select End Date",
        //           "dataTypeId": 3,
        //           "width": 3
        //         },
        //         {
        //           "fieldID": "address",
        //           "label": "Employer Address",
        //           "placeholder": "Enter Employer Address",
        //           "dataTypeId": 1,
        //           "width": 3,
        //           "transform": 1,
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "condition": "form_group.value['hasWorkedBefore'] == 1 ? 1 : 0",
        //               "value": "1"
        //             }
        //           }
        //         }
        //       ]
        //     },
        //     {
        //       "multiple": 0,
        //       "validators": {
        //         "min_length": 1,
        //         "max_length": 0
        //       },
        //       "fieldID": "empDocList",
        //       "label": "Current Employment Documents",
        //       "sub_section_display_type": 1,
        //       "sectionFields": [
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "condition": "parent_form.value.hasWorkedBefore == 1 ? 1 : 0",
        //               "value": "1"
        //             },
        //             "documentValidation": [
        //               "pdf",
        //               "doc",
        //               "docx",
        //               "jpeg",
        //               "png",
        //               "jpg",
        //               "xlsx",
        //               "xlsm",
        //               "jfif",
        //               "mp3",
        //               "ogv",
        //               "wav",
        //               "amr",
        //               "ogg",
        //               "xls",
        //               "svg"
        //             ]
        //           },
        //           "fieldID": "relLetterAttach",
        //           "label": "Relieving Letter",
        //           "placeholder": "Choose File",
        //           "width": 4,
        //           "dataTypeId": 5
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "condition": "parent_form.value.hasWorkedBefore == 1 ? 1 : 0",
        //               "value": "1"
        //             },
        //             "documentValidation": [
        //               "pdf",
        //               "doc",
        //               "docx",
        //               "jpeg",
        //               "png",
        //               "jpg",
        //               "xlsx",
        //               "xlsm",
        //               "jfif",
        //               "mp3",
        //               "ogv",
        //               "wav",
        //               "amr",
        //               "ogg",
        //               "xls",
        //               "svg"
        //             ]
        //           },
        //           "fieldID": "payslip1Attach",
        //           "label": "Payslip 1",
        //           "placeholder": "Choose File",
        //           "width": 4,
        //           "dataTypeId": 5
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "condition": "parent_form.value.hasWorkedBefore == 1 ? 1 : 0",
        //               "value": "1"
        //             },
        //             "documentValidation": [
        //               "pdf",
        //               "doc",
        //               "docx",
        //               "jpeg",
        //               "png",
        //               "jpg",
        //               "xlsx",
        //               "xlsm",
        //               "jfif",
        //               "mp3",
        //               "ogv",
        //               "wav",
        //               "amr",
        //               "ogg",
        //               "xls",
        //               "svg"
        //             ]
        //           },
        //           "fieldID": "payslip2Attach",
        //           "label": "Payslip 2",
        //           "placeholder": "Choose File",
        //           "width": 4,
        //           "dataTypeId": 5
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "condition": "parent_form.value.hasWorkedBefore == 1 ? 1 : 0",
        //               "value": "1"
        //             },
        //             "documentValidation": [
        //               "pdf",
        //               "doc",
        //               "docx",
        //               "jpeg",
        //               "png",
        //               "jpg",
        //               "xlsx",
        //               "xlsm",
        //               "jfif",
        //               "mp3",
        //               "ogv",
        //               "wav",
        //               "amr",
        //               "ogg",
        //               "xls",
        //               "svg"
        //             ]
        //           },
        //           "fieldID": "payslip3Attach",
        //           "label": "Payslip 3",
        //           "placeholder": "Choose File",
        //           "width": 4,
        //           "dataTypeId": 5
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "condition": "parent_form.value.hasWorkedBefore == 1 ? 1 : 0",
        //               "value": 0
        //             },
        //             "documentValidation": [
        //               "pdf",
        //               "doc",
        //               "docx",
        //               "jpeg",
        //               "png",
        //               "jpg",
        //               "xlsx",
        //               "xlsm",
        //               "jfif",
        //               "mp3",
        //               "ogv",
        //               "wav",
        //               "amr",
        //               "ogg",
        //               "xls",
        //               "svg"
        //             ]
        //           },
        //           "fieldID": "recentHikeAttach",
        //           "label": "Recent Hike Letter",
        //           "placeholder": "Choose File",
        //           "width": 4,
        //           "dataTypeId": 5
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "condition": "parent_form.value.hasWorkedBefore == 1 ? 1 : 0",
        //               "value": 0
        //             },
        //             "documentValidation": [
        //               "pdf",
        //               "doc",
        //               "docx",
        //               "jpeg",
        //               "png",
        //               "jpg",
        //               "xlsx",
        //               "xlsm",
        //               "jfif",
        //               "mp3",
        //               "ogv",
        //               "wav",
        //               "amr",
        //               "ogg",
        //               "xls",
        //               "svg"
        //             ]
        //           },
        //           "fieldID": "currCompOLAttach",
        //           "label": "Current Company Offer Letter",
        //           "placeholder": "Choose File",
        //           "width": 4,
        //           "dataTypeId": 5
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "condition": "parent_form.value.hasWorkedBefore == 1 ? 1 : 0",
        //               "value": "1"
        //             },
        //             "documentValidation": [
        //               "pdf",
        //               "doc",
        //               "docx",
        //               "jpeg",
        //               "png",
        //               "jpg",
        //               "xlsx",
        //               "xlsm",
        //               "jfif",
        //               "mp3",
        //               "ogv",
        //               "wav",
        //               "amr",
        //               "ogg",
        //               "xls",
        //               "svg"
        //             ]
        //           },
        //           "fieldID": "expLetterAttach",
        //           "label": "Experience letter",
        //           "placeholder": "Choose File",
        //           "width": 4,
        //           "dataTypeId": 5
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "condition": "parent_form.value.hasWorkedBefore == 1 ? 1 : 0",
        //               "value": "1"
        //             },
        //             "documentValidation": [
        //               "pdf",
        //               "doc",
        //               "docx",
        //               "jpeg",
        //               "png",
        //               "jpg",
        //               "xlsx",
        //               "xlsm",
        //               "jfif",
        //               "mp3",
        //               "ogv",
        //               "wav",
        //               "amr",
        //               "ogg",
        //               "xls",
        //               "svg"
        //             ]
        //           },
        //           "fieldID": "empResigAcceptedLetterAttach",
        //           "label": "Employee Resignation acceptance letter/ mail",
        //           "placeholder": "Choose File",
        //           "width": 4,
        //           "dataTypeId": 5
        //         }
        //       ]
        //     },
        //     {
        //       "validators": {
        //         "multiple": 0,
        //         "min_length": 0,
        //         "max_length": 0
        //       },
        //       "fieldID": "PFCovered_section",
        //       "label": "Have you been covered under PF in Last organization?",
        //       "multiple": 0,
        //       "display_type": "1",
        //       "enableQuestion": {
        //         "fieldID": "PFCovered",
        //         "label": "Have you been covered under PF in Last organization?",
        //         "masterPropName": "yesNoList",
        //         "UIValidationObjStruct": {
        //           "mandatory": {
        //             "value": 0
        //           }
        //         }
        //       },
        //       "sectionFields": [
        //         {
        //           "fieldID": "UANNumber",
        //           "label": "UAN Number",
        //           "placeholder": "Enter UAN Number",
        //           "dataTypeId": 1,
        //           "width": 3,
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "condition": "form_group.value['PFCovered'] == 1 ? 1 : 0",
        //               "value": ""
        //             },
        //             "min_length": {
        //               "value": 12
        //             },
        //             "max_length": {
        //               "value": 12
        //             }
        //           }
        //         },
        //         {
        //           "fieldID": "expiryDate",
        //           "label": "Last working Date in the company",
        //           "placeholder": "Select Last working Date in the company",
        //           "dataTypeId": 3,
        //           "width": 3,
        //           "parent_key": "extendedFields",
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "condition": "form_group.value['PFCovered'] == 1 ? 1 : 0",
        //               "value": ""
        //             }
        //           }
        //         },
        //         {
        //           "fieldID": "ENominationStatus",
        //           "label": "E-Nomination Status",
        //           "placeholder": "Select E-Nomination Status",
        //           "suggestedValues": [
        //             {
        //               "id": "Pending",
        //               "title": "Pending"
        //             },
        //             {
        //               "id": "Completed",
        //               "title": "Completed"
        //             }
        //           ],
        //           "dataTypeId": 12,
        //           "width": 3,
        //           "parent_key": "extendedFields",
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "condition": "form_group.value['PFCovered'] == 1 ? 1 : 0",
        //               "value": ""
        //             }
        //           }
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             },
        //             "hide": {
        //               "condition": "form_group.value['ENominationStatus'] == 'Pending' || !form_group.value['ENominationStatus'] ? 1 : 0",
        //               "value": "1"
        //             },
        //             "documentValidation": [
        //               "pdf",
        //               "doc",
        //               "docx",
        //               "jpeg",
        //               "png",
        //               "jpg",
        //               "xlsx",
        //               "xlsm",
        //               "jfif",
        //               "mp3",
        //               "ogv",
        //               "wav",
        //               "amr",
        //               "ogg",
        //               "xls",
        //               "svg"
        //             ]
        //           },
        //           "fieldID": "ENominationStatusAttach",
        //           "label": "Upload screenshot of completion",
        //           "placeholder": "Choose File",
        //           "parent_key": "extendedFields",
        //           "width": 3,
        //           "dataTypeId": 5
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "condition": "form_group.value['PFCovered'] == 1 ? 1 : 0",
        //               "value": "1"
        //             },
        //             "documentValidation": [
        //               "pdf",
        //               "doc",
        //               "docx",
        //               "jpeg",
        //               "png",
        //               "jpg",
        //               "xlsx",
        //               "xlsm",
        //               "jfif",
        //               "mp3",
        //               "ogv",
        //               "wav",
        //               "amr",
        //               "ogg",
        //               "xls",
        //               "svg"
        //             ]
        //           },
        //           "fieldID": "PFPassbookAttach",
        //           "label": "PF Passbook",
        //           "placeholder": "Choose File",
        //           "parent_key": "extendedFields",
        //           "width": 3,
        //           "dataTypeId": 5
        //         },
        //         {
        //           "fieldID": "previousPFNumber",
        //           "label": "Previous PF Number",
        //           "parent_key": "extendedFields",
        //           "placeholder": "Enter Previous PF Number",
        //           "dataTypeId": 1,
        //           "width": 3,
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "condition": "form_group.value['PFCovered'] == 1 ? 1 : 0",
        //               "value": ""
        //             }
        //           }
        //         },
        //         {
        //           "fieldID": "PFTrust",
        //           "label": "Provident fund trust",
        //           "placeholder": "Provident fund trust",
        //           "dataTypeId": 1,
        //           "width": 3,
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "condition": "form_group.value['PFCovered'] == 1 ? 1 : 0",
        //               "value": 0
        //             }
        //           }
        //         }
        //       ]
        //     },
        //     {
        //       "validators": {
        //         "multiple": 0,
        //         "min_length": 0,
        //         "max_length": 0,
        //         "hide": {
        //           "condition": "parent_form['value']['offeredCTC'] <= 252000 ? 0:1",
        //           "value": 0
        //         }
        //       },
        //       "fieldID": "EligibleForESI",
        //       "label": "Where you covered in ESIC previously?",
        //       "display_type": "1",
        //       "enableQuestion": {
        //         "fieldID": "isEligibleForESI",
        //         "label": "Where you covered in ESIC previously?",
        //         "masterPropName": "yesNoList",
        //         "UIValidationObjStruct": {
        //           "mandatory": {
        //             "value": 0
        //           }
        //         }
        //       },
        //       "sectionFields": [
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "condition": "form_group.value['isEligibleForESI'] == 1 ? 1 : 0",
        //               "value": ""
        //             },
        //             "max_length": 12,
        //             "pattern": {
        //               "value": "^[0-9]{2}[A-Za-z]{3}[0-9]{7}$"
        //             }
        //           },
        //           "fieldID": "ESINumber",
        //           "label": "ESIC Number",
        //           "placeholder": "Enter ESIC Number",
        //           "dataTypeId": 1,
        //           "width": 3
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "condition": "form_group.value['isEligibleForESI'] == 1 ? 1 : 0",
        //               "value": 0
        //             }
        //           },
        //           "fieldID": "ESIState",
        //           "label": "ESIC State",
        //           "placeholder": "Enter ESIC State",
        //           "dataTypeId": 1,
        //           "width": 3
        //         },
        //         {
        //           "fieldID": "ESIBranch",
        //           "label": "ESIC Branch",
        //           "placeholder": "Enter ESIC Branch",
        //           "dataTypeId": 1,
        //           "width": 3,
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "condition": "form_group.value['isEligibleForESI'] == 1 ? 1 : 0",
        //               "value": 0
        //             }
        //           }
        //         },
        //         {
        //           "fieldID": "ESIBranchDispensary",
        //           "label": "Branch Dispensary",
        //           "placeholder": "Enter Branch Dispensary",
        //           "dataTypeId": 1,
        //           "parent_key": "extendedFields",
        //           "width": 3,
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "condition": "form_group.value['isEligibleForESI'] == 1 ? 1 : 0",
        //               "value": 0
        //             }
        //           }
        //         }
        //       ]
        //     }
        //   ]
        // },
        // {
        //   "validators": {
        //     "multiple": 0,
        //     "min_length": 0,
        //     "max_length": 0
        //   },
        //   "fieldID": "offer_referenceAndAdditonalDetails",
        //   "label": "References Details",
        //   "sub_section_display_type": 1,
        //   "sections": [
        //     {
        //       "fieldID": "primaryReferences",
        //       "label": "References Details",
        //       "display_type": 1,
        //       "multiple": 1,
        //       "validators": {
        //         "min_length": 1,
        //         "max_length": 0
        //       },
        //       "sectionFields": [
        //         {
        //           "fieldID": "firstName",
        //           "label": "Name",
        //           "placeholder": "Enter Name",
        //           "dataTypeId": 1,
        //           "transform": 1,
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             }
        //           }
        //         },
        //         {
        //           "fieldID": "address",
        //           "label": "Address",
        //           "placeholder": "Enter Address",
        //           "dataTypeId": 1,
        //           "transform": 1,
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             }
        //           }
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             }
        //           },
        //           "fieldID": "mobileIsd",
        //           "numberControl": "mobileNumber",
        //           "label": "Mobile Number",
        //           "placeholder": "Select Country Code",
        //           "numberControlPlaceholder": "Enter number",
        //           "dataTypeId": 11
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             },
        //             "max_length": {
        //               "value": 10
        //             }
        //           },
        //           "fieldID": "phoneIsd",
        //           "numberControl": "phoneNumber",
        //           "label": "Phone Number",
        //           "placeholder": "Select Country Code",
        //           "numberControlPlaceholder": "Enter number",
        //           "dataTypeId": 11
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             }
        //           },
        //           "fieldID": "emailId",
        //           "label": "Official Email ID",
        //           "placeholder": "Enter Email ID",
        //           "dataTypeId": 1
        //         }
        //       ]
        //     }
        //   ]
        // },
        // {
        //   "validators": {
        //     "multiple": 0,
        //     "min_length": 0,
        //     "max_length": 0
        //   },
        //   "fieldID": "offer_familyDetails",
        //   "label": "Family Details",
        //   "sub_section_display_type": 1,
        //   "sectionFields": [],
        //   "sections": [
        //     {
        //       "fieldID": "familyDetails",
        //       "label": "Family Details",
        //       "display_type": 1,
        //       "multiple": 1,
        //       "validators": {
        //         "min_length": 1,
        //         "max_length": 0
        //       },
        //       "sectionFields": [
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": "1"
        //             }
        //           },
        //           "fieldID": "salutationId",
        //           "label": "Salutation",
        //           "placeholder": "Select Salutation",
        //           "masterPropName": "salutationList",
        //           "dataTypeId": 8,
        //           "width": 3
        //         },
        //         {
        //           "fieldID": "firstName",
        //           "label": "First Name",
        //           "placeholder": "Enter First Name",
        //           "dataTypeId": 1,
        //           "width": 3,
        //           "transform": 1,
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": "1"
        //             }
        //           }
        //         },
        //         {
        //           "fieldID": "middleName",
        //           "label": "Middle Name",
        //           "placeholder": "Enter Middle Name",
        //           "dataTypeId": 1,
        //           "width": 3,
        //           "transform": 1,
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": "1"
        //             }
        //           }
        //         },
        //         {
        //           "fieldID": "lastName",
        //           "label": "Last Name",
        //           "placeholder": "Enter Last Name",
        //           "dataTypeId": 1,
        //           "width": 3,
        //           "transform": 1,
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": "1"
        //             }
        //           }
        //         },
        //         {
        //           "fieldID": "relationTypeId",
        //           "label": "Relationship To Employee",
        //           "placeholder": "< - - Select - - >",
        //           "masterPropName": "relationTypeList",
        //           "dataTypeId": 8,
        //           "width": 3,
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": "1"
        //             }
        //           }
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": "1"
        //             }
        //           },
        //           "fieldID": "dob",
        //           "label": "Date of birth",
        //           "placeholder": "Select Date of birth",
        //           "dataTypeId": 3,
        //           "width": 3
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": "1"
        //             }
        //           },
        //           "fieldID": "gender",
        //           "label": "Gender",
        //           "placeholder": "Select Gender",
        //           "masterPropName": "genderList",
        //           "dataTypeId": 8,
        //           "width": 3
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": "1"
        //             }
        //           },
        //           "fieldID": "nationalityId",
        //           "label": "Nationality",
        //           "placeholder": "<--Select-->",
        //           "masterPropName": "nationalityList",
        //           "dataTypeId": 8,
        //           "width": 3
        //         },
        //         {
        //           "fieldID": "occupation",
        //           "label": "Occupation",
        //           "placeholder": "Enter Occupation",
        //           "dataTypeId": 1,
        //           "width": 3,
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": "1"
        //             }
        //           }
        //         },
        //         {
        //           "fieldID": "address",
        //           "label": "Address",
        //           "placeholder": "Enter Address",
        //           "dataTypeId": 1,
        //           "width": 3,
        //           "transform": 1,
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": "1"
        //             }
        //           }
        //         }
        //       ]
        //     },
        //     {
        //       "fieldID": "nomineeDetails",
        //       "label": "Nominee Details",
        //       "display_type": 1,
        //       "multiple": 1,
        //       "validators": {
        //         "min_length": 1,
        //         "max_length": 0
        //       },
        //       "sectionFields": [
        //         {
        //           "fieldID": "name",
        //           "label": "Nominee Name",
        //           "placeholder": "Enter name",
        //           "dataTypeId": 8,
        //           "transform": 1,
        //           "isDataMaster": {
        //             "options_key": "familyDetails"
        //           },
        //           "id_property": "firstName",
        //           "title_property": "firstName",
        //           "expression": "form_group.get('relationTypeId').enable();form_group.get('dob').enable();form_group.patchValue(ev);form_group.get('age').patchValue(new Date().getFullYear() - new Date(ev.dob).getFullYear())",
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             }
        //           }
        //         },
        //         {
        //           "fieldID": "nomineeTypeId",
        //           "label": "Nomination Type",
        //           "placeholder": "Select Type",
        //           "masterPropName": "nomineeTypeList",
        //           "dataTypeId": 8,
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": "1"
        //             }
        //           }
        //         },
        //         {
        //           "fieldID": "relationTypeId",
        //           "label": "Relationship To Employee",
        //           "placeholder": "< - - Select - - >",
        //           "masterPropName": "relationTypeList",
        //           "dataTypeId": 8,
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 1
        //             },
        //             "disabled": {
        //               "value": 1
        //             }
        //           }
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             }
        //           },
        //           "fieldID": "age",
        //           "label": "Age of Nominee",
        //           "placeholder": "Enter Age",
        //           "dataTypeId": 2
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             },
        //             "disabled": {
        //               "value": 1
        //             }
        //           },
        //           "fieldID": "dob",
        //           "label": "Date of birth",
        //           "placeholder": "Select Date of birth",
        //           "dataTypeId": 3
        //         },
        //         {
        //           "fieldID": "address",
        //           "label": "Nominee Address",
        //           "placeholder": "Enter Address",
        //           "dataTypeId": 1,
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 1
        //             }
        //           }
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             },
        //             "pattern": {
        //               "value": "^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$"
        //             }
        //           },
        //           "fieldID": "aadharNumber",
        //           "label": "Aadhar Number",
        //           "placeholder": "Enter Aadhar Number",
        //           "width": 4,
        //           "dataTypeId": 1
        //         },
        //         {
        //           "fieldID": "percentageShare",
        //           "label": "Percentage of benefit",
        //           "placeholder": "%",
        //           "dataTypeId": 2,
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 1
        //             },
        //             "max_length": {
        //               "value": 3
        //             },
        //             "max_value": {
        //               "value": 100
        //             }
        //           }
        //         },
        //         {
        //           "UIValidationObjStruct": {
        //             "mandatory": {
        //               "value": 0
        //             }
        //           },
        //           "fieldID": "isMinorNominee",
        //           "label": "Is nominee minor?",
        //           "placeholder": " ",
        //           "width": 4,
        //           "dataTypeId": 13
        //         }
        //       ]
        //     }
        //   ]
        // },
        // {
        //   "fieldID": "documents",
        //   "label": "Other Documents",
        //   "display_type": 1,
        //   "multiple": 0,
        //   "validators": {
        //     "min_length": 1,
        //     "max_length": 0
        //   },
        //   "sectionFields": [
        //     {
        //       "fieldID": "extendedData",
        //       "label": "Other Documents",
        //       "masterPropName": "offerDocuments",
        //       "dataTypeId": 16,
        //       "width": 12,
        //       "skipVerification": 1,
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": "1"
        //         }
        //       }
        //     }
        //   ]
        // },
        // {
        //   "fieldID": "offerDeclarationDocuments",
        //   "label": "Acknowledgement",
        //   "display_type": 1,
        //   "multiple": 0,
        //   "validators": {
        //     "multiple": 0,
        //     "min_length": 0,
        //     "max_length": 0
        //   },
        //   "sectionFields": [
        //     {
        //       "fieldID": "offerDeclarationDocuments",
        //       "label": "Acknowledgement",
        //       "skipVerification": 1,
        //       "masterPropName": "offerDeclarationDocuments",
        //       "dataTypeId": 23,
        //       "width": 12,
        //       "disableDownload": 1
        //     }
        //   ]
        // },
        // {
        //   "fieldID": "statutoryFormsDocuments",
        //   "label": "Statutory Forms",
        //   "display_type": 1,
        //   "additionalKeysBody": {
        //     "finalSubmit": 1
        //   },
        //   "multiple": 0,
        //   "validators": {
        //     "min_length": 1,
        //     "max_length": 0
        //   },
        //   "sectionFields": [
        //     {
        //       "fieldID": "statutoryFormsDocuments",
        //       "label": "Statutory",
        //       "masterPropName": "statutoryFormsDocuments",
        //       "dataTypeId": 16,
        //       "width": 12,
        //       "skipVerification": 1,
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": "1"
        //         }
        //       }
        //     }
        //   ]
        // },
        // {
        //   "fieldID": "offer_declaration",
        //   "label": "Declaration & Confirmation",
        //   "display_type": 1,
        //   "multiple": 0,
        //   "additionalKeysBody": {
        //     "finalSubmit": 1
        //   },
        //   "hasDocument": {
        //     "keys": [
        //       "onbDeclarationSignature"
        //     ]
        //   },
        //   "sectionFields": [
        //     {
        //       "fieldID": "declaration",
        //       "label": "I hereby confirm that the information provided herein is accurate and complete and that the documents submitted are genuine..",
        //       "dataTypeId": 18,
        //       "width": 12,
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": "1"
        //         }
        //       }
        //     },
        //     {
        //       "UIValidationObjStruct": {
        //         "mandatory": {
        //           "value": "1"
        //         }
        //       },
        //       "fieldID": "onbDeclarationSignature",
        //       "ipFieldID": "onbDeclarationIP",
        //       "placeFieldID": "onbDeclarationPlace",
        //       "dateFieldID": "onbDeclarationDt",
        //       "label": "Signature",
        //       "actionText": "Candidate has Signed the documents ",
        //       "dataTypeId": 14,
        //       "width": 4,
        //       "controlClass": "offset-md-8"
        //     }
        //   ]
        // }
        // ]
        this.prepareSections(this.dynamic_sections, this.dynamic_form, this.fb, 1, this.form_details, this.dynamic_form);
        this.patchValueToFormGroups()
        // if (this.masters.currencyList && this.masters.currencyList.length) {
        //   // setDefaultValue(this.empInfo, 'presentCTCCurrencyId', this.masters.currencyList, 'id');
        //   setDefaultValue(this.personal_details_form, 'expectedCTCCurrencyId', this.masters.currencyList, 'id');
        // }
        // if (this.masters.durationList && this.masters.durationList.length) {
        //   // setDefaultValue(this.empInfo, 'presentCTCDurationId', this.masters.durationList, 'id');
        //   setDefaultValue(this.personal_details_form, 'expectedCTCDurationId', this.masters.durationList, 'id');
        // }
        // if (this.masters.countryList && this.masters.countryList.length) {
        //   setDefaultValue(this.personal_details_form, 'mobileIsd', this.masters.countryList, 'id');
        //   setDefaultValue(this.personal_details_form, 'landLineIsd', this.masters.isdCountryList, 'id');
        //   setDefaultValue(this.personal_details_form, 'altMobileIsd', this.masters.isdCountryList, 'id');
        //   setDefaultValue(this.personal_details_form, 'emergencyContactIsd', this.masters.isdCountryList, 'id');
        // }

        // if (this.masters && this.masters.assessmentList) {
        //   this.masters.assessmentList = jsonDeepParse(this.masters.assessmentList);
        //   this.masters.assessmentList.forEach(element => {
        //     let form_array = this.ref_and_other_details_form.get('assessment') as FormArray
        //     form_array.push(this.createAssessment(element));
        //   });
        // }
        // if (this.masters && this.masters.checklist) {
        //   this.masters.checklist = jsonDeepParse(this.masters.checklist);
        //   this.masters.checklist.forEach(element => {
        //     let form_array = this.ref_and_other_details_form.get('checklist') as FormArray
        //     form_array.push(this.createCheckList(element));
        //   });
        // }

        // if (this.masters && this.masters.extendedData) {
        //   this.masters.extendedData.forEach(element => {
        //     element = jsonDeepParse(element);
        //     let form_array = this.extendedData.get('extendedData') as FormArray
        //     form_array.push(this.createExtendeDOCUMENTS(element));
        //   });
        // }

        // if (this.masters && this.masters.offerDocuments) {
        //   this.masters.offerDocuments.forEach(element => {
        //     let form_array = this.extendedData.get('offerDocuments') as FormArray
        //     form_array.push(CHthis.createExtendeDOCUMENTS(element));
        //   });
        // }



      }
    })
  }


  scrollToError(): void {
    const firstElementWithError = document.querySelector(
      ".ng-invalid[formControlName]"
    );

    this.scrollTo(firstElementWithError);
  }

  scrollTo(el: Element): void {

    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  // addressLine1: new FormControl(null),
  // addressLine2: new FormControl(null),
  // cityId: new FormControl(null),
  // stateId: new FormControl(null),
  // countryId: new FormControl(null),
  // postalCode: new FormControl(null),
  // attachments: new FormControl(null),
  // copyAddress() {
  //   if (!this.personal_details_form.value.localAddress.addressLine1) {
  //     this.personal_details_form.get('permanentAddress').patchValue({
  //       addressLine1: this.personal_details_form.value.localAddress.addressLine1,
  //       addressLine2: this.personal_details_form.value.localAddress.addressLine2,
  //       cityId: this.personal_details_form.value.localAddress.cityId,
  //       stateId: this.personal_details_form.value.localAddress.stateId,
  //       countryId: this.personal_details_form.value.localAddress.countryId,
  //       postalCode: this.personal_details_form.value.localAddress.postalCode,
  //       attachments: this.personal_details_form.value.localAddress.attachments,
  //     })
  //   }
  //   else {
  //     this.dialog.open(ConfirmationComponent, {
  //       width: "480px",
  //       height: "auto",
  //       panelClass: "icr-dialog",
  //       data: {
  //         title: "ERROR.confirmation",
  //         message: "OFFER.existing_data_will_be_replaced_by_communication_address",
  //         positive_button: "BTN.yes",
  //         negative_button: "BTN.no"
  //       },
  //     }).afterClosed().subscribe((res) => {
  //       if (res) {
  //         this.personal_details_form.get('permanentAddress').patchValue({
  //           addressLine1: this.personal_details_form.value.localAddress.addressLine1,
  //           addressLine2: this.personal_details_form.value.localAddress.addressLine2,
  //           cityId: this.personal_details_form.value.localAddress.cityId,
  //           stateId: this.personal_details_form.value.localAddress.stateId,
  //           countryId: this.personal_details_form.value.localAddress.countryId,
  //           postalCode: this.personal_details_form.value.localAddress.postalCode,
  //           attachments: this.personal_details_form.value.localAddress.attachments,
  //         })
  //       }
  //     });
  //   }

  // }

  uploadDocument(base64, type, file_name = "digital-sign.png") {
    return new Observable(obs => {
      if (type == 1) {
        try {
          let file = this.dataURLtoFile(base64, file_name)
          let form_data = new FormData();
          form_data.append('attachment', file, file.name);
          this.notification_svc.success('FILES.uploading_attachments', 'Close', 3000);
          this.file_srv.uploadAttachment(form_data).subscribe(res => {

            let attach = {}
            if (res && res['data']) {

              attach['fileName'] = res['data']['a_fn'];
              attach['cdnPath'] = res['data']["a_url"];
              this.notification_svc.success(res['message'], 'Close', 3000);
              obs.next(attach)
              // attach['width'] = this.result_dimentions[0].width
              // attach['height'] = this.result_dimentions[0].heigh
            }
            else {
              obs.next(0)
              this.notification_svc.error(res && res['message'], 'Close', 3000);
            }
          }, err => {
            obs.next(0);
          })
        } catch (error) {
          obs.next(0)
        }
      }
      else if (type == 2) {
        obs.next(0)
      }
    })

  }

  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }


  formDetails(ev) {
    this.prepareExtendedFields(this.dynamic_sections, ev);
    if (ev.extended_fields_titles && Object.keys(ev.extended_fields_titles) && Object.keys(ev.extended_fields_titles).length) {
      for (let index = 0; index < Object.keys(ev.extended_fields_titles).length; index++) {
        let key = Object.keys(ev.extended_fields_titles)[index];
        Object.assign(ev['value'][key], ev.extended_fields_titles[key])
      }
    }
    console.log(ev);
    this.submitPreOfferDetails(ev);
  }
  prepareExtendedFields(sections, data) {

    for (let i = 0; i < sections.length; i++) {
      let section = sections[i];
      if (section && section.parent_key) {
        let key_val = {};
        key_val[section['fieldID']] = data.value[section.fieldID]

        if (data.value[section.parent_key]) {
          data.value[section.parent_key] = Object.assign(data.value[section.parent_key], key_val);
          delete data.value[section.fieldID];
        }
        else {
          data.value[section.parent_key] = {};
          data.value[section.parent_key] = Object.assign(data.value[section.parent_key], key_val);
          delete data.value[section.fieldID];
        }
      }

      if (!section.parent_key && section.sectionFields && section.sectionFields.length) {
        for (let j = 0; j < section.sectionFields.length; j++) {
          let field = section.sectionFields[j];
          if (field && field.parent_key) {
            let key_val = {};
            key_val[field['fieldID']] = data.value[field.fieldID]

            if (data.value[field.parent_key]) {
              data.value[field.parent_key] = Object.assign(data.value[field.parent_key], key_val);
              delete data.value[field.fieldID];
            }
            else {
              data.value[field.parent_key] = {};
              data.value[field.parent_key] = Object.assign(data.value[field.parent_key], key_val);
              delete data.value[field.fieldID];
            }
          }
        }
      }
      if (section.sections && section.sections.length) {
        this.prepareExtendedFields(section.sections, data)
      }
    }
  }
}

export function prepareMasters(field, details, masters, section) {
  try {
    if (field && field.enable_virtual_scroll && field.masterPropName && !section.multiple) {
      let obj = {};
      if (typeof details[field.fieldID] == 'object' && details[field.fieldID].length) {
        //
        if (!masters[field.masterPropName].length) {
          masters[field.masterPropName] = [];
        }
        for (let index = 0; index < details[field.fieldID].length; index++) {
          let element = details[field.fieldID][index];
          obj[field.title_property || 'title'] = details[field.masterTitleProperty][index];
          obj[field.id_property || 'id'] = element;
          masters[field.masterPropName].push(obj);
        }
      }
      else {
        obj[field.title_property || 'title'] = details[field.masterTitleProperty];
        obj[field.id_property || 'id'] = details[field.fieldID];
        masters[field.masterPropName].push(obj);
      }
      masters[field.masterPropName] = cloneArray(masters[field.masterPropName]);
    }
    if (field && field.enable_virtual_scroll && field.masterPropName && section.multiple) {

      if (typeof details[section.fieldID] == 'object' && details[section.fieldID].length) {
        //
        if (!masters[field.masterPropName].length) {
          masters[field.masterPropName] = [];
        }
        for (let index = 0; index < details[section.fieldID].length; index++) {
          let element = details[section.fieldID][index];
          let obj = {};
          obj[field.title_property || 'title'] = element[field.masterTitleProperty];
          obj[field.id_property || 'id'] = element[field.fieldID];
          masters[field.masterPropName].push(obj);
        }
      }
      else {
        let obj = {};
        obj[field.title_property || 'title'] = details[field.masterTitleProperty];
        obj[field.id_property || 'id'] = details[field.fieldID];
        masters[field.masterPropName].push(obj);
      }
      masters[field.masterPropName] = cloneArray(masters[field.masterPropName]);
    }
  }
  catch (err) {

  }
}

